import { API } from 'services';

export function getContracts(params) {
  const queryParams = new URLSearchParams(params).toString();

  return API({
    endpoint: `/contract?${queryParams}`,
  });
}

export function getContractsProvider(params) {
  const queryParams = new URLSearchParams(params).toString();

  return API({
    endpoint: `/contract/provider?${queryParams}`,
  });
}

export function getContractsSeller(sellerId) {
  return API({
    endpoint: `/contract/seller/${sellerId}`,
  });
}

export function getContract({ id, ...params }) {
  return API({
    endpoint: `/contract/detail/${id}`,
    ...params
  })
}

export function createContract(body, companyId){
  return API({
    method: 'POST',
    endpoint: `/contract/${companyId}`,
    body,
  })
}

export function cancelContract(contractId){
  return API({
    method: 'PUT',
    endpoint: `/contract/status/cancel/${contractId}`,
  })
}


export function contractPayment({ id, ...params }) {
  return API({
    method: 'POST',
    endpoint: `/contract/payment/${id}`,
    ...params
  })
}

export function getInstallments(contractId){
  return API({
    endpoint: `/installment/contract/${contractId}`,
  })
}

export function chargeInstallments({ body, ...params }){
  return API({
    method: 'POST',
    endpoint: `/installment/charge`,
    body,
    ...params
  })
}

export function getContractParams() {
  return API({
    endpoint: `/contract-params`
  })
}

export function updateContractParamsGlobal({ body, ...params }) {
  return API({
    method: 'PUT',
    endpoint: `/contract-params`,
    body,
    ...params
  })
}

export function updateContractParams({ id, body}) {
  return API({
    method: 'PUT',
    endpoint: `/contract/updateContractParams/${id}`,
    body,
  })
}

export function getBillingReceipt({ id, ...params }) {
  return API({
    endpoint: `/openpix/billing-receipt/${id}`,
    ...params
  })
}

export function getPaymentVoucher({ id, ...params }) {
  return API({
    endpoint: `/openpix/payment-voucher/${id}`,
    ...params
  })
}

export function uploadFile({ id, ...params }) {
  return API({
    method: 'POST',
    endpoint: `/contract/file/${id}`,
    ...params
  });
}

export function updateInstallmentMaturity({ contractId, body }) {
  return API({
    method: 'PUT',
    endpoint: `/installment/updateMaturity/${contractId}`,
    body,
  })
}

export function createExternalCharge({ contractId, body }) {
  return API({
    method: 'POST',
    endpoint: `/externalCharge/${contractId}`,
    body,
  })
}

export function getExternalChargeStatus({ externalChargeId }) {
  return API({
    endpoint: `/externalCharge/${externalChargeId}/status`,
  })
}

export function createExternalChargeRecovery({ externalChargeId, body }) {
  return API({
    method: 'PUT',
    endpoint: `/externalCharge/${externalChargeId}/recovery`,
    body,
  })
}

export function cancelExternalCharge({ externalChargeId }) {
  return API({
    method: 'PUT',
    endpoint: `/externalCharge/${externalChargeId}/cancel`,
  })
}

export function refundExternalCharge({ externalChargeId, body }) {
  return API({
    method: 'PUT',
    endpoint: `/externalCharge/${externalChargeId}/refund`,
    body,
  })
}
